module.exports = __webpack_public_path__ + "static/accounts.48bd594a.png";


//////////////////
// WEBPACK FOOTER
// /Users/grantmaclennan/code/_archive/Toos/src/images/accounts.png
// module id = 179
// module chunks = 0